

import {EMOJI_SELECTED} from "~/constants/bus";
import ChatRoom from "@/models/chat-room";
import * as rpc from "@/constants/rpc";
import RoomMember from "@/models/room-member";
import ChatMessage from "@/models/chat-message";
import {MQTT_TOPIC_CHAT, MQTT_TOPIC_QOS, MQTT_TOPIC_RETAIN} from "@/constants/mqtt";
import {CHAT_MSG_NEW} from "@/constants/chat";
import {URL_CHAT} from "@/constants/rpc";
import upload, {MB} from "@/utils/upload";
import user from "@/mixins/user";

export default {
    name: "ChatRoom",
    mixins: [user],
    props: {
        myUserId: 0,
        room: {
            type: ChatRoom,
            default() {
                return new ChatRoom()
            }
        },
    },
    data() {
        return {
            tableIndex: 0,
            pageCurrent: 1,
            pageSize: 20,
            total: 0,
            says: [],

            histories: [],
            members: [],
            memberMap: {},

            text: '',
            emojiVisible: false,
            dialogVisible: false,

            file:null,
            uploading:false,
            chatUrl: URL_CHAT,
        }
    },
    created() {
        this.$bus.$on(EMOJI_SELECTED, msg => {
            this.emojiVisible = false
            this.text += msg
        })
        this.listRoomMembers()
        this.joinMqtt()
    },
    destroyed() {
        this.leaveMqtt()
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs["chat-list"].addEventListener("scroll", this.handleScroll);
        });
    },
    methods: {
        onSend() {
            if (!this.text) {
                this.$message.error("请输入消息内容")
                return
            }
            this.sendMessage(this.text)
        },
        sendMessage(text) {
            let newSay = {
                roomId: this.room._id,
                fromUserId: this.myUserId,
                statusId: CHAT_MSG_NEW,
                content: text,
            }

            const topic = MQTT_TOPIC_CHAT.replace("roomId", this.room._id)
            this.$mqtt.publish(topic, JSON.stringify(newSay), {
                qos: MQTT_TOPIC_QOS,
                retain: MQTT_TOPIC_RETAIN
            })
        },
        async listRoomMembers() {
            const p = {_id: this.room._id}
            const ret = await this.$axios.rpcMsg(rpc.CHAT, rpc.CHAT_ROOM_LIST_MEMBER, p)
            if (ret && ret.result) {
                let newArray = []
                for (let i = 0; i < ret.result.length; i++) {
                    let c = new RoomMember(ret.result[i])
                    newArray.push(c)
                    let id = c.memberUser?._id ?? 0
                    if (id > 0) {
                        this.memberMap[id] = c
                    }
                }
                this.members = newArray
                await this.getRoomMessageCount()
            }
        },
        async getRoomMessageCount() {
            const p = {
                roomId: this.room._id,
                tableIndex: this.tableIndex,
            }
            const ret = await this.$axios.rpcMsg(rpc.CHAT, rpc.CHAT_MSG_GET_COUNT, p)
            if (ret && ret.result) {
                this.total = ret.result.count
                if (this.total > 0) {
                    await this.getRoomMessageByPage()
                }
            }
        },
        async getRoomMessageByPage() {
            const p = {
                roomId: this.room._id,
                tableIndex: this.tableIndex,
                pageNum: this.pageCurrent - 1,
                pageSize: this.pageSize
            }
            const ret = await this.$axios.rpcMsg(rpc.CHAT, rpc.CHAT_MSG_GET_PAGE, p)
            if (ret && ret.result) {
                for (let i = 0; i < ret.result.length; i++) {
                    let c = new ChatMessage(ret.result[i])
                    let roomMember = this.memberMap[c.fromUserId]
                    if (roomMember) {
                        c.fromUser = roomMember.memberUser
                    }
                    this.says.unshift(c)
                }
                this.scrollTo(ret.result.length - 1)
            }
        },
        joinMqtt() {
            console.log("joinMqtt")
            this.$mqtt.addListener(this)
            if (this.$mqtt.isConnected()) {
                console.log("joinMqtt #1, isConnected")
                this.onConnected()
            } else {
                console.log("joinMqtt #2, reconnect")
                this.$mqtt.reconnect()
            }
        },
        onConnected() {
            const topic = MQTT_TOPIC_CHAT.replace("roomId", this.room._id)
            this.$mqtt.subscribe(topic, {
                qos: MQTT_TOPIC_QOS,
                retain: MQTT_TOPIC_RETAIN
            })
        },
        onMessage(topic, payload, packet) {
            let newSay = JSON.parse(payload)
            let c = new ChatMessage(newSay)
            let roomMember = this.memberMap[c.fromUserId]
            if (roomMember) {
                c.fromUser = roomMember.memberUser
            }
            this.says.push(c)
            this.text = ""
            this.scrollTo(this.says.length - 1)
        },
        leaveMqtt() {
            console.log("leaveMqtt")
            this.$mqtt.removeListener(this)
        },
        scrollTo(itemIndex) {
            this.$nextTick(() => {
                let el = this.$refs["chat-list"].querySelector("#chatItem" + itemIndex)
                if (el) {
                    console.log("#chatItem" + itemIndex + ":offsetTop=" + el.offsetTop)
                    this.$refs["chat-list"].scrollTop = el.offsetTop
                }
            });
        },
        handleScroll() {
            const scrollTop = this.$refs["chat-list"].scrollTop;
            if (scrollTop == 0) {
                //当前页码到达上限后，可以执行一次换表操作，只有一次
                this.pageCurrent++
                if (this.pageCurrent <= this.pageSize) {
                    this.getRoomMessageByPage()
                } else if (this.tableIndex == 0) {
                    this.tableIndex++
                    this.pageCurrent = 1
                    this.getRoomMessageCount()
                }
            }
        },
        handleUpload(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
        },
        handlePaste(event) {
            const items = (event.clipboardData || window.clipboardData).items
            let file = null
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地或请打开图片再复制')
                return
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile()
                    break
                }
            }
            if (!file) {
                this.$message.error('粘贴内容非图片')
                return
            }

            const reader = new FileReader();
            reader.onload = event => {
                this.$refs['preview'].innerHTML = `<img src="${event.target.result}" width="300px" style="margin-top: 10px">`;
            };
            reader.readAsDataURL(file);

            this.file = file
            this.dialogVisible = true
        },
        async uploadFile() {
            this.uploading = true
            const ret = await this.$axios.uploadFile(rpc.URL_CHAT, this.file)
            const url = ret?.data?.data?.ossUrl ?? ""
            if (url) {
                this.sendMessage(url)
            }
            this.uploading = false
            this.dialogVisible = false
        },
        handleSuccess(res, file) {
            if (res && res.code == 200 && res.data) {
                this.sendMessage(res.data.ossUrl)
            }
        },
        beforeImageUpload(file) {
            let {ok, msg} = upload.validateUploadImage(file, 2*MB)
            if (!ok) {
                this.$message.error(msg);
            }
            return ok
        },
        beforeDocUpload(file) {
            let {ok, msg} = upload.validateUploadDoc(file, 5*MB)
            if (!ok) {
                this.$message.error(msg);
            }
            return ok
        },
    }

}
